const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
const Utils = {
	getBrowserVersion: () => {
		try {
			const ua = navigator.userAgent;
			let tem;
			let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
			if (/trident/i.test(M[1])) {
				tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
				return `IE ${tem[1] || ''}`;
				// return 'IE '+(tem[1] || '');
			}
			if (M[1] === 'Chrome') {
				tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
				if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
			}
			M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
			tem = ua.match(/version\/(\d+)/i);
			if (tem != null) M.splice(1, 1, tem[1]);
			return M.join(' ');
		} catch (error) {
			return 'error';
		}
	},

	formatLength: length => {
		let l = 0;
		let n = parseInt(length, 10) || 0;

		while (n >= 1024) {
			l += 1;
			n /= 1024;
		}
		return `${n.toFixed(n >= 10 || l < 1 ? 1 : 2)} ${units[l]}`;
	},
	isValidFile: file => {
		const isJpg = file.type === 'image/jpg' || file.type === 'image/jpeg';
		const isPng = file.type === 'image/png';
		const isLt21mb = file.size / 1024 / 1024 < 21;
		return (isJpg || isPng) && isLt21mb;
	},
	isJpeg: file => {
		const isJpg = file.type === 'image/jpg' || file.type === 'image/jpeg';
		const isLt21mb = file.size / 1024 / 1024 < 21;
		return isJpg && isLt21mb;
	},
	isPngAtuallyJpg: async file => {
		const header = await new Response(file.slice(0, 4)).arrayBuffer();
		const uint = new Uint8Array(header);
		const bytes = [];
		uint.forEach(byte => {
			bytes.push(byte.toString(16));
		});
		const hex = bytes.join('').toUpperCase();
		return hex === 'FFD8FFDB' || hex === 'FFD8FFE0' || hex === 'FFD8FFE1';
	},
	isMacOS: () => {
		const { userAgent, appVersion } = window.navigator;
		return userAgent.indexOf('Mac') > -1
			|| appVersion.indexOf('Mac') > -1;
	}
};

export default Utils;



// WEBPACK FOOTER //
// ./src/Utils.js